// import { Toaster } from "../components/ui/toaster";
// import { Toaster as Sonner } from "../components/ui/sonner";
import './index.css';

import { BrowserRouter, Route, Routes } from 'react-router-dom';

// import { TooltipProvider } from "../components/ui/tooltip";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import Index from './pages/Index';
import NotFound from './pages/NotFound';

const queryClient = new QueryClient();

// const App = () => (
  // <QueryClientProvider client={queryClient}>
    // {/* <TooltipProvider> */}
    // {/* <Toaster /> */}
    // {/* <Sonner /> */}
    // <BrowserRouter>
      // <Routes>
        // <Route path="/" element={<Index />} />
        // {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
        // <Route path="*" element={<NotFound />} />
      // </Routes>
    // </BrowserRouter>
    // {/* </TooltipProvider> */}
  // </QueryClientProvider>
// );

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Index />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  )
}


